import { render, staticRenderFns } from "./AddNewRepair.vue?vue&type=template&id=56441397&scoped=true&"
import script from "./AddNewRepair.vue?vue&type=script&lang=js&"
export * from "./AddNewRepair.vue?vue&type=script&lang=js&"
import style0 from "./AddNewRepair.vue?vue&type=style&index=0&id=56441397&lang=scss&scoped=true&"
import style1 from "./AddNewRepair.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56441397",
  null
  
)

export default component.exports